module.exports = __webpack_public_path__ + "img/dylan-image.c63f35eb.jpg";